import { z } from "zod";
// ── Node / Edge schemas ───────────────────────────────────────────────────────
export const DataGraphNodeSchema = z.object({
    id: z.string(),
    kind: z.string(),
    label: z.string(),
    integrationSource: z.string().optional(),
    attributes: z.record(z.string(), z.unknown()).optional(),
});
export const DataGraphEdgeSchema = z.object({
    id: z.string(),
    from: z.string(),
    to: z.string(),
    kind: z.string(),
    attributes: z.record(z.string(), z.unknown()).optional(),
});
export const DataGraphResponseSchema = z.object({
    nodes: z.array(DataGraphNodeSchema),
    edges: z.array(DataGraphEdgeSchema),
});
// ── Rebuild ───────────────────────────────────────────────────────────────────
export const RebuildGraphRequestSchema = z.object({
    triggeredBy: z.enum(["manual", "scheduled"]).optional(),
    model: z.string().optional(),
    fromScratch: z.boolean().optional(),
});
export const RebuildGraphResponseSchema = z.object({
    workflowId: z.string(),
});
export const RebuildStatusResponseSchema = z.object({
    isRunning: z.boolean(),
    status: z.string().nullable(),
    workflowId: z.string(),
    startedAt: z.string().nullable(),
});
// ── Traversal ─────────────────────────────────────────────────────────────────
export const TraversalResponseSchema = z.object({
    nodes: z.array(DataGraphNodeSchema),
    edges: z.array(DataGraphEdgeSchema),
});
// ── Impact ────────────────────────────────────────────────────────────────────
export const ImpactResponseSchema = z.object({
    totalNodes: z.number(),
    byKind: z.record(z.string(), z.number()),
    nodes: z.array(DataGraphNodeSchema),
    edges: z.array(DataGraphEdgeSchema),
});
// ── Snapshots ─────────────────────────────────────────────────────────────────
export const DataGraphSnapshotSummarySchema = z.object({
    id: z.string(),
    label: z.string(),
    createdAt: z.union([z.string(), z.date()]),
});
export const CreateSnapshotRequestSchema = z.object({ label: z.string().min(1) });
export const CreateSnapshotResponseSchema = z.object({ id: z.string() });
export const RestoreSnapshotResponseSchema = z.object({ restored: z.boolean() });
